<template>
  <div class="about-page">
    <section class="about-hero" :style="heroStyle">
      <div class="content-width">
        <p class="eyebrow">{{ $store.getters.t('about') }}</p>
        <h1>{{ siteConfig.siteName || $store.getters.t('about') }}</h1>
      </div>
    </section>
    <section class="about-copy content-width">
      <p class="eyebrow">{{ siteConfig.siteName || 'MOTO' }}</p>
      <h2>{{ $store.getters.t('aboutHeadline') }}</h2>
      <p>{{ $store.getters.t('aboutCopy') }}</p>
      <div class="about-contact">
        <span v-if="siteConfig.contactEmail">{{ siteConfig.contactEmail }}</span>
        <span v-if="siteConfig.contactPhone">{{ siteConfig.contactPhone }}</span>
        <span v-if="siteConfig.contactAddress">{{ siteConfig.contactAddress }}</span>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AboutView',
  computed: {
    siteConfig () { return this.$store.state.siteConfig },
    heroStyle () {
      const banner = this.$store.state.banners[0]
      return banner && banner.imageUrl ? { backgroundImage: `url("${banner.imageUrl}")` } : {}
    }
  }
}
</script>
